import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { Link } from 'react-router-dom';


const useStyles = makeStyles(() => {
  return {
    btnCurvedRed: {
      backgroundColor: '#b31b19',
      display: 'flex',
      flexDirection: 'column',
      color: '#fff',
      maxWidth: 'fit-content',
      margin: '40px auto',
      border: 'none',
      borderRadius: '30px',
      padding: '4px 20px',
      textDecoration: 'none',
      '&:hover': {
        color: '#fff',
        textDecoration: 'none',
      },
    },
    header: {
      margin: 0,
      color: '#fff',
      fontWeight: 'lighter',
    },
    headerBold: {
      margin: 0,
      color: '#fff',
      fontWeight: 'bolder',
    },
    alignRight: {
      margin: 'auto 0px 0px auto',
      '@media (max-width: 992px)': { margin: 'auto' },
    },
  };
});


const DEFAULT_CHECKOUT_URL = '/account/purchase';

function SubscribeCTAButton(props) {
  const { title, topText, alignRight } = props;
  const classes = useStyles();
  const url = title === 'NAKED NEWS LIVE' ? `${DEFAULT_CHECKOUT_URL}?_anchor=241&_shortUrl=live` : DEFAULT_CHECKOUT_URL;


  if (topText === 'BECOME A') {
    return (
      <Link
        className={
          classnames(
            classes.btnCurvedRed,
            { [classes.alignRight]: alignRight }
          )
        } to={url}
      >
        <h4 className={classes.header}>{topText}</h4>
        <h3 className={classes.headerBold}>{title}</h3>
      </Link>
    );
  }

  return (
    <Link
      className={
        classnames(
          classes.btnCurvedRed,
          { [classes.alignRight]: alignRight }
        )
      } to={url}
    >
      <h4 className={classes.header}>{topText}</h4>
      <h4 className={classes.headerBold}>{title}</h4>
    </Link>
  );
}

export default SubscribeCTAButton;

SubscribeCTAButton.propTypes = {
  alignRight: PropTypes.bool,
  title: PropTypes.string,
  topText: PropTypes.string,
};

SubscribeCTAButton.defaultProps = {
  title: 'NAKED NEWS',
  topText: 'SUBSCRIBE TO',
  alignRight: false,
};
